<template>
  <a class="LinkMetadata" :href="item.url">
    <div class="LinkMetadata_container">
        <div>
            <div style="font-size: 18px;">{{item.title}}</div>
            <div style="font-size: 14px;">{{item.description}}</div>
            <div style="font-size: 12px;">{{item.hostName}}</div>
        </div>
      <div style="border-bottom: 1px solid #eaecef;">
        <img style="width: 250px; height: auto;" :src="`${item.imageUrl}`" :alt="item.siteName" />
      </div>
    </div>
  </a>
</template>


<script>
export default {
  props: ["item"]
}
</script>

<style scoped>
.LinkMetadata {
    text-decoration:none;
    color: var(--textGeneralColor);
}
.LinkMetadata_container{
    height: 100%;
    border-left: 2px solid #006EFF;
    padding-left: 5px;
    margin-left: 5px;
    margin-top: 5px;
}
</style>
